import { Row, Col } from 'antd'
import dayjs from 'dayjs'

import _map from 'lodash/map'

import Title from 'components/Title'
import Link from 'components/Link'

import asyncComponent from 'utils/asyncComponent'

import Styled from './styled'

const ArticleRecommend = asyncComponent(() => import('components/ArticleRecommend'))
const AffixArticleCategories = asyncComponent(() =>
  import('components/Affix/AffixArticleCategories')
)
const CardArticleGrid = asyncComponent(() => import('components/Card/CardArticleGrid'))

export default function ArticleCategory({ articles, articleType }) {
  const categorySlug = articleType?.code
  const title = articleType?.name

  const pathname = `/blog/${categorySlug}`

  return (
    <Styled>
      <div className="blog-container">
        <AffixArticleCategories tab={categorySlug} />

        <div className="container">
          <div className="blog-content">
            <Row
              gutter={[
                { xs: 0, sm: 0, md: 0, lg: 50 },
                { xs: 0, sm: 0, md: 0, lg: 50 },
              ]}
            >
              <Col span={24} lg={17}>
                <div className="article-content">
                  <div className="title-block">
                    <Title level={1} className="title">
                      {title}
                    </Title>
                  </div>

                  <div className="list-container">
                    <Row
                      gutter={[
                        { xs: 10, sm: 10, md: 16, lg: 45 },
                        { xs: 16, sm: 16, md: 16, lg: 16 },
                      ]}
                    >
                      {_map(articles, (item, index) => {
                        const slug = item?.code
                        const link = `${pathname}/${slug}`

                        return (
                          <Col span={24} md={12} key={index}>
                            <Link href={link}>
                              <CardArticleGrid
                                categories={item?.categories}
                                title={item?.title}
                                detail={item?.shortDescription}
                                image={item?.thumbnailImage?.[0]?.url}
                              />
                            </Link>
                          </Col>
                        )
                      })}
                    </Row>
                  </div>
                </div>
              </Col>

              <Col span={24} lg={7}>
                <ArticleRecommend />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Styled>
  )
}
